import { render, staticRenderFns } from "./NameHistory.vue?vue&type=template&id=43128d5e"
import script from "./NameHistory.vue?vue&type=script&lang=js"
export * from "./NameHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports